<template>
  <div class="categories-list">
    <div
      class="category-name"
      :class="{'selected': categoryId === null}"
      @click="goToCategoryDetail()"
    >
      {{ $i18nPresenter.t('All') }}
    </div>
    <div
      @click="goToCategoryDetail(category.id)"
      v-for="category in categories"
      :key="category.id"
      :class="{
        'selected': categoryId === category.id,
        'selecting': isSelectingCategory == category.id
      }"
      class="category-name"
    >
      <span
        :class="{
          'opacity-0' : isSelectingCategory == category.id,
          'selected': categoryId === category.id,
        }"
      >
        {{ $i18nPresenter.t(category.shortName) }}
      </span>
      <span
        class="absolute opacity-0 left-0 right-0
        mx-auto aha-spinner aha-spinner--white aha-spinner--xs"
        :class="{'opacity-100' : isSelectingCategory == category.id}"
      ></span>
    </div>
  </div>
</template>

<script>
import CategoryApi from '@/api/category'
import Utils from '@/util'
import EventBus from '@/eventBus'

export default {
  components: {
  },
  props: {
    categoryId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      categories: [],
      clickingToScroll: null,
      isSelectingCategory: -1,
    }
  },
  created() {
    this.getAllCategories()
  },
  mounted() {
    this.eventBusCategoryLoadingListener()
  },
  destroyed() {
    EventBus.$off('template-library--category-loaded')
  },
  methods: {
    async getAllCategories() {
      const res = await CategoryApi.getAllCategories()
      this.categories = res.data
    },
    goToCategoryDetail(id) {
      if (id) {
        this.isSelectingCategory = id
        this.$router.push(`/apps/template-library/category/${id}`)
        Utils.mixpanelTracking('Template Library > Open Category', 'Open Category', '', id)
      } else {
        this.$router.push('/apps/template-library')
      }
    },
    eventBusCategoryLoadingListener() {
      EventBus.$on('template-library--category-loaded', () => {
        this.isSelectingCategory = -1
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.category-name {
  padding: 8px 16px;
  border-radius: 40px;
  background-color: #fff;
  border: 1px solid #D3D7E1;
  cursor: pointer;
  margin-right: 8px;
  transition: all 0.3s ease;
  display: inline-block;
  margin-bottom: 8px;
  position: relative;
  &.active, &:hover, &:focus {
    border-color: #348EF6;
    color: #348EF6;
  }
  &.selected, &:focus {
    background-color: #348EF6;
    color: #fff;
    border-color: #348EF6;
  }
  &.selecting {
    background-color: #348EF6;
    cursor: none;
  }
}

.categories-list {
  margin-bottom: 16px;
}

@media (max-width: 960px) {
  .categories-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space:nowrap;
    padding: 2px;
  }
}
</style>
